(function() {
  function getFilterKey(section) {
    var slide = section.querySelector('.keen-slider-slide, .grid-item');
    if (!slide) return 'tab';
    if (slide.dataset.tab !== undefined) return 'tab';
    if (slide.dataset.collection !== undefined) return 'collection';
    return 'tab';
  }

  function getSlideSelector(section) {
    return section.querySelector('.grid-item') ? '.grid-item' : '.keen-slider-slide';
  }

  function showSlidesForValue(section, value) {
    var filterKey = getFilterKey(section);
    var slideSelector = getSlideSelector(section);
    section.querySelectorAll(slideSelector).forEach(function(slide) {
      slide.style.display = slide.dataset[filterKey] === value ? '' : 'none';
    });
    var carousel = section.querySelector('component-carousel');
    if (carousel && carousel.sliderObj) {
      carousel.sliderObj.refresh();
    }
  }

  function initSection(section) {
    if (section.dataset.multiItemFilterInit === 'true') return;
    section.dataset.multiItemFilterInit = 'true';

    var selectors = section.querySelectorAll('[name$="-collection-selector"]');
    selectors.forEach(function(element) {
      element.addEventListener('change', function() {
        showSlidesForValue(section, element.value);
      });
    });

    
  }

  function initAll(root) {
    (root || document).querySelectorAll('.type-featured-collections-tabs').forEach(initSection);
  }

  initAll();

  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
})();
